import './LessonCompletion.css';

const LessonCompletion = ({
  question,
  characterImage,
  confettiImage,
 
}) => {
  const descriptions = Array.isArray(
    question?.descriptionExplanation
  )
    ? question.descriptionExplanation.filter(
        (description) =>
          typeof description === 'string' &&
          description.trim() !== ''
      )
    : [];

  return (
    <div className="lesson-completion">
      <div className="lesson-completion__content">
        <div className="lesson-completion__bubble">
          {question?.titleExplanation || 'Felicitari! 🎉'}
        </div>

        <div className="lesson-completion__visual">
          {characterImage && (
            <img
              src={characterImage}
              alt="Lectie finalizata"
              className="lesson-completion__character"
            />
          )}

          {confettiImage && (
            <img
              src={confettiImage}
              alt=""
              aria-hidden="true"
              className="lesson-completion__confetti"
            />
          )}
        </div>

        <h3 className="lesson-completion__title">
          Lectie finalizata!
        </h3>

        {descriptions.length > 0 && (
          <div className="lesson-completion__descriptions">
            {descriptions.map((description, index) => (
              <div
                key={index}
                className="lesson-completion__description"
                dangerouslySetInnerHTML={{
                  __html: description,
                }}
              />
            ))}
          </div>
        )}

      
      </div>
    </div>
  );
};

export default LessonCompletion;